import React, { useState, useEffect } from 'react';
import { withPrefix } from 'gatsby';
import { css } from '@emotion/react';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import Modal from 'react-modal';

export type PhaseInfoSectionProps = {
  className?: string;
};

export const PhaseInfoSection: React.FC<PhaseInfoSectionProps> = ({
  className,
}) => {
  
  const [isStepNum, setIsStepNum] = useState(0);
  
  const [isStep1ContentsNum, setIsStep1ContentsNum] = useState(1);
  
  const [isOpenModalVisible, setIsOpenModalVisible] = useState(false);
  const [isOpenModalNum, setIsOpenModalNum] = useState(0);
  
  function openModal(num) {
    setIsOpenModalNum(num);
    setIsOpenModalVisible(true);
  }
  function closeModal() {
    setIsOpenModalNum(0);
    setIsOpenModalVisible(false);
  }
  
  function changeStepNum(num) {
    setIsStepNum(num);
  }
  
  function changeStep1Contents1Num(num) {
    setIsStep1ContentsNum(num);
  }
  
  const [windowWidth, setWindowWidth] = useState(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);

      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);

      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  if (!windowWidth) return null;
  
  
  const step1_list = [
    {
      id: 1,
      phase_name: 'シード期',
      img_step1_src: withPrefix('/images/phaseinfo/step1_seed_icon.png'),
      img_step1_width: 94,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_seed_titlebg.png'),
      img_step2_title_width: 284,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_seed_bgicon.png'),
      img_step2_icon_width: 174,
      phase_text: '創業期は、事業立ち上げ間もない時期です。志を同じくする数名で事業を立ち上げ、徐々に組織の形を整えていく創業期に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "会社設立をサポートしてほしい",
        "創業期にあったWebサイトを作りたい",
        "人事業務をサポートしてほしい",
      ],
    },
    {
      id: 2,
      phase_name: 'N-3期',
      img_step1_src: withPrefix('/images/phaseinfo/step1_n3_icon.png'),
      img_step1_width: 100,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_n3_titlebg.png'),
      img_step2_title_width: 318,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_n3_bgicon.png'),
      img_step2_icon_width: 185,
      phase_text: 'N-3期は、事業基盤の強化と成長戦略の策定を進める時期です。事業モデルの再評価や収益基盤の安定化が求められるN-3期に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "規程・マニュアル作成に着手したい",
        "監査法人のショートレビューを受けないと",
        "資金調達をサポートしてほしい",
      ],
    },
    {
      id: 3,
      phase_name: 'N-2期',
      img_step1_src: withPrefix('/images/phaseinfo/step1_n2_icon.png'),
      img_step1_width: 100,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_n2_titlebg.png'),
      img_step2_title_width: 288,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_n2_bgicon.png'),
      img_step2_icon_width: 190,
      phase_text: 'N-2期は、内部統制の整備や経営管理体制の強化が求められます。資本政策の見直しや、経営管理体制の強化も重要なテーマであるN-2期に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "内部監査をはじめたい",
        "規程・マニュアルを作成したい",
        "社外監査役が見つからない",
      ],
    },
    {
      id: 4,
      phase_name: 'N-1期',
      img_step1_src: withPrefix('/images/phaseinfo/step1_n1_icon.png'),
      img_step1_width: 110,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_n1_titlebg.png'),
      img_step2_title_width: 275,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_n1_bgicon.png'),
      img_step2_icon_width: 185,
      phase_text: 'N-1期は、IPO直前の準備段階です。監査法人や証券会社との連携を深め、法務・財務面での最終調整を行うN-1期に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "Ⅰの部の作成をサポートしてほしい",
        "Ⅱの部/各種説明資料の作成が大変",
        "従業員向けに各種研修を実施したい",
      ],
    },
    {
      id: 5,
      phase_name: 'N期',
      img_step1_src: withPrefix('/images/phaseinfo/step1_n_icon.png'),
      img_step1_width: 110,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_n_titlebg.png'),
      img_step2_title_width: 280,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_n_bgicon.png'),
      img_step2_icon_width: 190,
      phase_text: 'N期は、IPOの準備が最終段階に達する時期です。上場後を見据えたガバナンス体制の確立などが求められるN期に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "上場申請のための資料作成が大変",
        "上場前に会社のブランドイメージをアップデートしたい",
        "ロードショー資料を作成したい",
      ],
    },
    {
      id: 6,
      phase_name: '上場後',
      img_step1_src: withPrefix('/images/phaseinfo/step1_after_icon.png'),
      img_step1_width: 115,
      img_step2_title_src: withPrefix('/images/phaseinfo/step2_after_titlebg.png'),
      img_step2_title_width: 282,
      img_step2_icon_src: withPrefix('/images/phaseinfo/step2_after_bgicon.png'),
      img_step2_icon_width: 186,
      phase_text: '上場後は、事業拡大や収益基盤の強化が求められます。ガバナンスの徹底と市場での信頼確保も求められる上場後に発生しがちな課題には、どのようなものがあるでしょうか。',
      phase_list: [
        "管理部門担当者を増強したい",
        "決算開示プロセスをDX化したい",
        "社内資料の統一化を図りたい",
      ],
    },
  ]
  const step2_list = [
    {
      id: 101,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '会社設立をサポートしてほしい',
      modal_text: '会社を設立する予定。設立前・設立後それぞれにおいて、作成が必要なもの、外部への提出が求められるものがたくさんある。作成・届出の手続きについてサポートしてほしい！',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '法人設立サポートサービス',
      modal_feature_list: [
        '多岐にわたる対応事項や煩雑な申請フローをマルっとサポート！',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>新地',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_shinchi.png'),
      modal_commenter_text: '会社の設立は、限られた時間の中で様々な事柄を決定し、処理していかなければなりません。創業者様の負担を軽減し、安心して本業に注力いただけるよう、しっかりと伴走支援いたします。',
      modal_link: '/',
    },
    {
      id: 102,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '創業期に最適なWebサイトを作りたい',
      modal_text: '自社の目指す世界観が伝わり、他のスタートアップ企業と差別化できるWebサイトを作りたいが、そもそもどのようなWebサイトにすれば良いのかわからない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'デザイン支援サービス',
      modal_feature_list: [
        'MVVの策定からWebデザインまで、貴社の伝えたいことを言語化、ビジュアル化',
      ],
      modal_commenter_name: 'デザイナー<br>戸澤',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_tozawa.png'),
      modal_commenter_text: '創業期のWebサイトでは「目的の明確化」と「最小限の規模でリリース」を重視し小回りの利くサイトにすることが重要です。また提供価値や対象顧客を定め、しっかりと伝わるようにデザインいたします。',
      modal_link: '/',
    },
    {
      id: 103,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: 'シェアオフィスを探したい',
      modal_text: '小さくても良いから、法人住所を構えるためのシェアオフィスを探しているが、いくつか条件を比較しながら決めたい！',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '最適な仲介会社をご紹介',
      modal_feature_list: [
        '機能性重視、駅チカ重視、エリア重視など様々なニーズに合わせてピッタリなプレーヤーを紹介',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '多くのスタートアップ企業に対して、フェーズごとに求められるサポートを提案してきたノウハウをもとに、貴社の現状や今後のコーポレートアクションに合わせたソリューションを紹介させていただきます。',
      modal_link: '/',
    },
    {
      id: 104,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '人事業務をサポートしてほしい',
      modal_text: 'まだ企業規模が小さく、人事労務・給与計算などの業務について専任の担当者を採用するほどではないが、社外にサポートしてくれる機能がほしい！',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人事労務・給与計算立ち上げサポートサービス',
      modal_feature_list: [
        '創業メンバー（役員やコア従業員）の労務・給与計算について、システム導入をはじめとした管理体制の構築と安定的な代行を実施',
      ],
      modal_commenter_name: '公認会計士<br>加藤',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: '社会保険/税金/給与計算など専門性が高く、将来を見据えた体制構築（システム等含む）が必要な部分について、丁寧にヒアリングを行い体制整備し、安定的な業務代行を実施します。',
      modal_link: '/',
    },
    {
      id: 105,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '採用業務をサポートしてほしい',
      modal_text: '経営陣がスカウトやエージェント開拓など採用業務を担っている。工数の限界を迎えつつあるが、採用責任者の採用はフェーズ的にまだ考えていない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'RPOサービス',
      modal_feature_list: [
        'エージェント管理や書類選考、面接など、採用業務の一部または全部を代行',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>本田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_honda.png'),
      modal_commenter_text: '優秀な人材確保は重要ですが、経営陣の時間は有限。<br>「書類エントリーから１次面接まで」など採用プロセスを一部切り出して依頼することで、重要な採用プロセスにはしっかり関与しつつ、効率化を図ることが可能です。',
      modal_link: '/',
    },
    {
      id: 106,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '株主総会の資料をつくらないと',
      modal_text: '創業したばかり。まだ株主も少なく株主総会を開いたことがない。これからしっかり開催したいと考えているけど、会社法で定められる招集手続や決議事項、必要資料がよくわからない！',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: 'テンプレート機能＆経営コンサル',
      modal_feature_list: [
        '株主総会議事録や招集通知のテンプレートを提供',
        '運営サポートに関するコンサルティングも',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '上場有無に関係なくすべての株式会社が開催すべき株主総会ですが、株主数が限定的なことなどから簡便的に対応されているケースが少なくありません。ミス・漏れ・無駄のない総会対応を進めていきましょう。',
      modal_link: '/',
    },
    {
      id: 107,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '人材採用を強化したい',
      modal_text: '事業が拡大してきたので、マネージャークラスや管理部門の人員を強化したい。<br>当社のフェーズや目指すビジョンにマッチした人を採用したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        'スタートアップや上場準備フェーズを経験した人材の登録数◎',
        '採用機能の一括請負実績も豊富',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>本田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_honda.png'),
      modal_commenter_text: 'スタートアップの採用は慎重に行うことが重要。候補者のキャリア志向と企業のビジョンに乖離がある場合、早期離職に繋がりやすくなります。人材紹介はもちろんのこと、採用設計からスカウトに限らない採用手法をご提案します。',
      modal_link: '/',
    },
    {
      id: 108,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '上場を意識した論点整理を始めたい',
      modal_text: 'いつか上場したいと考えているけど、現時点でどこまで整備できているのか、これからどの順番でどこまで整備するべきかわからない。上場準備を始める前にプロジェクトの全体像を把握したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'クイックレビューサービス',
      modal_feature_list: [
        '専門家とのヒアリングを通じて、現在地と上場に求められる水準をそれぞれ正しく認識することで、自社にとって最適な上場準備プロジェクトスケジュールを！',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '上場準備で大きな失敗を防ぐコツは、上場準備プロジェクトを開始する前に、自社の課題と対応策をしっかりと把握することと、“自社にとって”の最適なスケジュールを設定することです。',
      modal_link: '/',
    },
    {
      id: 109,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '資金調達したい',
      modal_text: '新規事業や事業拡大、プロダクト開発のための資金を集めたい。誰に何を相談すれば資金調達が成功するかわからないため、計画も含めて相談できるパートナーを探している。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '各ラウンドで資金調達を成功させた経験をもつコンサルタントとビジネスや経営を理解したデザイナーが伴走し、投資家の勘所を押さえた資料を作成',
      ],
      modal_commenter_name: '資金調達コンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: '投資の決定までには多くの人が関与するため、情報が正確に伝わることが重要です。自社の魅力を決定者に届けるには、信頼性のある数字と見やすいデザインを組み合わせた資料が必要不可欠です。',
      modal_link: '/',
    },
    {
      id: 110,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '士業の専門家に相談・連携したい',
      modal_text: '事業の拡大と合わせて、様々な悩みや懸念事項、将来に向けた対応など、各分野の専門家に相談したい。定期的に相談できる顧問契約やアドバイザリー契約も検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '公認会計士によるバックオフィスのトータルサポート',
      modal_feature_list: [
        '社外CFOとして、上場準備企業やベンチャー企業のバックオフィスについて知見のある公認会計士等がサポート',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: 'IPOやM&Aを目指すにあたり、バックオフィスがボトルネックとならないように、将来を見据えて先手先手で体制整備と運用を実施する必要があります！',
      modal_link: '/',
    },
    {
      id: 111,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '会計システムを導入したい',
      modal_text: '正しい財務諸表を作成するため、日々の取引を帳簿に記録して決算を行う一連の業務が求められている。正確性・効率性UPのため、帳簿や決算書などの作成・管理をサポートできる会計システムを導入したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '会計システム導入から決算早期化までのトータルサポート',
      modal_feature_list: [
        '社内で早期に月次決算を締め、資金繰り管理や予実管理を行える体制を目指し、システムやワークフローの検討から実装、安定的な運用までサポート！',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>新地',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_shinchi.png'),
      modal_commenter_text: '会計システムは、経理財務面だけではなく会社全体の内部統制（ワークフロー）構築にも影響を与えるため、将来の事業構想に合う形で導入する必要があります！',
      modal_link: '/',
    },
    {
      id: 112,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '管理業務をアウトソースしたい',
      modal_text: '管理部の人手が足りず、既存メンバーが自分の業務に集中できない。本来の専門性の高い業務やコア業務に集中してもらうために、経理や給与計算・採用などの業務を外部にアウトソースしたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '管理業務体制構築と運用代行サービス',
      modal_feature_list: [
        '非効率な管理業務体制がある場合はそのブラッシュアップを先に行い、複雑な管理業務についても経験豊富なメンバーによる運用代行を実施します。',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: 'IPOやM&Aを目指す過程で、徐々に内製化に移行する会社様も多いため、マニュアル作成やメンバーの教育を含めた支援も可能です！',
      modal_link: '/',
    },
    {
      id: 113,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: 'VCを紹介してほしい',
      modal_text: '資金調達を検討しており、VC・CVCと面談したいが、そもそも投資家に知り合いがいない。またどうやって投資家にアプローチすればいいかもわからない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '事業計画作成や株価算定のみならず、貴社ニーズに合わせた投資家との橋渡しサポート',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'VC、CVCにはむやみにアプローチしても会えるものではありません。まずは1社に事業の魅力が伝わることが重要なので、誰が見ても魅力が伝わるようなストーリーや資料を準備することが重要です。',
      modal_link: '/',
    },
    {
      id: 114,
      phase_id: 1,
      phase_name: 'シード期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_seed_icon.png'),
      modal_title: '上場準備スケジュールを設定したい',
      modal_text: 'いつか上場したいと考えているが、自社にとって何のために上場するのか、最適なタイミングはいつなのか、どれくらい準備に時間を要するのか、いろいろ整理してから上場準備に向き合いたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'クイックレビューサービス',
      modal_feature_list: [
        '市況や貴社の業績、管理体制の整備状況などを勘案し、最適な上場準備スケジュールとオーダーメイドの上場準備プロジェクトを共創',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '上場準備プロセスは数年にわたる長期プロジェクトです。課題着手の優先度や、自社の主要論点を早期に把握することで、自社にとって無理のない上場スケジュールが策定できます。',
      modal_link: '/',
    },
    {
      id: 201,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: 'そろそろオフィス移転したい',
      modal_text: '従業員数が増えて席が足りなくなってきた。会社の規模に合わせてセキュリティ対策もしていかないといけない。上場に向けて勢いがつくような、自社のフェーズにあったオフィス移転をサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '最適な仲介会社をご紹介',
      modal_feature_list: [
        '機能性重視、駅チカ重視、エリア重視など様々なニーズにあわせてピッタリなプレーヤーを紹介',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '企業の皆さまが出社したくなるオフィス、重厚感のあるオフィス、人員を倍に増加させても大丈夫なオフィス、上場日を迎えることになるオフィス、様々な想いが詰まったご希望をご相談ください。',
      modal_link: '/',
    },
    {
      id: 202,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: 'CxOを採用したい',
      modal_text: '体系的な組織を構築中。事業を伸長させるCOO、CSOを採用したい。また、そろそろIPO準備にも取り掛かりたいので、管理部門を管掌するCFOを採用したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        'スタートアップや上場準備フェーズを経験した人材の登録数◎',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'CFO採用の難易度は幹部人材の中でもトップクラスに高いです。<br>事業や企業の状況を解像度高く伝えることのできる経験豊富なコンサルタントが、経営陣と相性が良く発揮してほしい強みがマッチする候補者をお繋ぎします。',
      modal_link: '/',
    },
    {
      id: 203,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '予算をはじめて作成したい',
      modal_text: 'これまでもなんとなく目標数値は設定して事業運営してきたが、IPO準備において求められる予算策定ロジックや、適切な予算作成プロセスについて教えてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '予算作成から予算統制までトータルサポート',
      modal_feature_list: [
        '上場企業に求められる予算管理体制に昇華させるために、適切な予算作成から予実分析、予算変更等を可能にする作成支援や代行を実施',
      ],
      modal_commenter_name: '公認会計士<br>加藤',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: '予算や中期経営計画は、各ステークホルダーに対するコミットメントとしての性質がありますので、パブリックの会社として予算統制について最短最速のPDCAが回せるような体制が必要です！',
      modal_link: '/',
    },
    {
      id: 204,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '社員のモチベーションを上げたい',
      modal_text: 'これからまだまだ会社は成長する。みんなで一丸となって盛り上げていこう！<br>従業員のエンゲージメントを高めるため、持株会やストックオプションの導入を検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '株式報酬制度設計サービス',
      modal_feature_list: [
        '株式報酬制度設計サービス',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '株式報酬制度は、従業員のモチベーションを上げたり、株主である経営陣と同じ目線を持ってもらえたり、優秀な人材の流出を防ぐことなどに対して有効な施策となります。期待する効果や想いが付与対象者に届くよう、綿密に設計しましょう。',
      modal_link: '/',
    },
    {
      id: 205,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '監査法人のショートレビューを受けないと',
      modal_text: 'IPOに向けた管理体制も少しずつ整備できてきた。N-2期が開始する前に監査法人のショートレビューを受けたいので、監査法人を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '監査法人紹介サービス',
      modal_feature_list: [
        '事業展開している業界や成長スピードを鑑み、最適な監査法人をご紹介！',
      ],
      modal_commenter_name: '公認会計士<br>加藤',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: '将来の経営展望（自社の事業領域や海外志向性、目標としている上場市場など）から、逆算的かつ能動的に監査法人を選択しないと、後々監査法人を変更せざるを得ない場合もあるため、選定には留意が必要です。',
      modal_link: '/',
    },
    {
      id: 206,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '社労士法人の労務DDを受けないと',
      modal_text: 'IPO準備において労務関連の指摘があった場合、上場スケジュールに大きなインパクトを与えることが多いらしい！IPOに詳しい社労士事務所に労務DDを実施してもらい、課題の有無を整理したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '社労士事務所連携',
      modal_feature_list: [
        'IPOに強い社会保険労務士事務所と連携',
        '労務関連の課題は早期の発見が重要！',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: 'IPOに関する労務論点を網羅できる社労士事務所と連携し、N-3期中に労務DDを実施しましょう。上場スケジュールの延期に直結しやすい、労務関連のネガティブサプライズを防止・対応することが可能です。',
      modal_link: '/',
    },
    {
      id: 207,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '規程・マニュアル作成に着手したい',
      modal_text: '上場までには大量の規程・マニュアルの作成が求められるらしい。規程の雛形・サンプルを入手したい。また、自社の実態に整合した規程にアップデートしたいが、社内リソースだけでは負荷が大きいので作成をサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '規程作成支援サービス',
      modal_feature_list: [
        '規程のテンプレートをご提供',
        '貴社実態に整合した規程の作成をハンズオン支援',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '上場までに求められる規程は少なくとも50個あると言われています。多岐にわたるテンプレートの提供が可能なほか、自社内で作業リソースが確保できない場合でも、実態に即した規程へのアップデートを伴走支援いたします。',
      modal_link: '/',
    },
    {
      id: 208,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '監査役を選任したい',
      modal_text: '上場に向けて役員構成を検討中。常勤・非常勤の監査役を探しているが、なかなか見つからない。自社のビジネスモデルや規模にピッタリな監査役候補者を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        '監査役紹介',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>本田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_honda.png'),
      modal_commenter_text: '上場においては複数名の監査役で構成する監査役会の設置が求められます。規模やビジネスモデルのみならず経営陣との相性にマッチする方を選定することが重要です。',
      modal_link: '/',
    },
    {
      id: 209,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '取締役会の運営を効率化したい',
      modal_text: '毎月開催する取締役会において、招集手続き、業績報告、議事録作成などに時間を要しており、他の業務に支障が出ている。取締役会での議論は充実させつつ、効率化できる部分は効率化したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '取締役会の運営サポート',
      modal_feature_list: [
        '上場審査において求められる「適切な取締役会運営」を早期に自社運用',
        '内製化できるよう伴走サポート',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '取締役会の運営には役員構成や会社法に従った開催など定められた様式があり、それに加えて関連資料の充実や開催の早期化が求められます。取締役会運営に関与してきたメンバーが、効率化できる部分についてご支援します。',
      modal_link: '/',
    },
    {
      id: 210,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '監査法人のショートレビューの指摘事項に順次対応していきたい',
      modal_text: '監査法人のショートレビューを受けたけど、指摘された課題事項について対応・着手できていない。特定の担当者のみがエクセル等で課題の進捗管理を行うのではなく、役割分担、優先度設定を行い、進捗や関連資料を一元管理できるようにしたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: 'IPO準備クラウド',
      modal_feature_list: [
        'プリセットされたIPOタスクだけではなく、追加したタスクのプロジェクト管理ツールとしても大活躍',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '監査法人のショートレビューで指摘された課題には、それぞれ対応期限が設定されております。対応進捗によっては上場日程の延期に繋がります。社内外で密に連携し、効率的に進捗管理をしてまいりましょう。',
      modal_link: '/',
    },
    {
      id: 211,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '上場に向けて組織図をアップデートしたい',
      modal_text: '上場準備においては体系的に整理された組織図が必要らしい。適切な人員配置や兼務の解消を意識しつつ、将来の組織図もイメージしながら、現時点で適切な組織図を作成したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '組織体制の構築サポート',
      modal_feature_list: [
        '規程や業務フロー作成の土台となる組織体制構築をサポート',
        '他社事例などを参考に、貴社フェーズに合った組織図へアップデート',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '組織図は、企業内の役割分担の状況のみならず、企業の内部統制レベルや管理体制の充実度を示すものにもなります。上場準備を機に、人員配置や兼務などについて、適切な組織図にアップデートしましょう。',
      modal_link: '/',
    },
    {
      id: 212,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '資金調達をサポートしてほしい',
      modal_text: '新規事業や事業拡大、プロダクト開発のための資金を集めたい！<br>誰に何を相談すれば資金調達が成功するかわからないため、計画も含めて相談できるパートナーを探している。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '各ラウンドで資金調達を成功させた経験をもつコンサルタントとビジネスや経営を理解したデザイナーが伴走し、投資家の勘所を押さえた資料を作成',
      ],
      modal_commenter_name: '資金調達コンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: '投資の決定までには多くの人が関与するため、情報が正確に伝わることが重要です。自社の魅力を決定者に届けるには、信頼性のある数字と見やすいデザインを組み合わせた資料が必要不可欠です。',
      modal_link: '/',
    },
    {
      id: 213,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '反社チェックツールを導入したい',
      modal_text: '適切な取引開始判断を行うために反社チェックを導入したいけど、具体的な業務フローやチェックすべき範囲・頻度、使用すべきツールについてわからないのでサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '反社チェックサービス',
      modal_feature_list: [
        '当社を通じて連携する反社チェックツールを使用可能',
        'チェックの一括請負も対応可能',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '反社調査は一般的に反社チェックツールを用いて実施します。新規契約先のみならず継続取引先を含む全取引先について、懸念有無の確認とその証跡を残すことが必要となります。',
      modal_link: '/',
    },
    {
      id: 214,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '証券会社を紹介してほしい',
      modal_text: '上場準備において最も近い伴走者となるのが主幹事証券会社。ビジネスモデルを理解してくれた上で、しっかりサポートしてくれる担当者に担当してほしいので、自社にピッタリな証券会社を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '証券会社のご紹介',
      modal_feature_list: [
        '大手証券会社、中堅証券会社をご紹介',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '上場において、証券会社は最も重要な機能のひとつです。ビジネスモデルの理解、サポートしてくれる担当者、上場時のバリュエーション等を勘案し、自社にピッタリな証券会社を選定することが重要です。',
      modal_link: '/',
    },
    {
      id: 215,
      phase_id: 2,
      phase_name: 'N-3期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n3_icon.png'),
      modal_title: '規程・マニュアルを作成したい',
      modal_text: '上場までには大量の規程・マニュアルの作成が求められるらしい。規程の雛形・サンプルを入手したい。また、自社の実態に整合した規程にアップデートしたいが、社内リソースだけでは負荷が大きいので作成をサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: '規程作成支援サービス',
      modal_feature_list: [
        '規程のテンプレートをご提供',
        '貴社実態に整合した規程の作成をハンズオン支援',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '上場までに求められる規程は少なくとも50個あると言われています。多岐にわたるテンプレートの提供が可能なほか、自社内で作業リソースが確保できない場合でも、貴社実態に即した規程へのアップデートを伴走支援いたします。',
      modal_link: '/',
    },
    {
      id: 301,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '内部監査をはじめたい',
      modal_text: '内部監査を実施したいけれど…。担当者がいない、なにをすれば良いかわからない、作成すべき書類がわからない、社内で対応するリソースが不足しているなど、課題が山積み！内部監査を伴走サポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: '内部監査業務構築サポート',
      modal_feature_list: [
        '内部監査室の立ち上げを包括的にご支援',
        '将来的には内製化できるようノウハウ蓄積しながら伴走',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: 'ほとんどの場合、初めて内部監査を経験されるご担当者ばかり。一方で、関連資料の作成や、他部署の理解と協力を得ること等、簡単な役割ではありません。伴走しながら体制構築し、その後自社だけでも運用できる体制になるまでご支援します。',
      modal_link: '/',
    },
    {
      id: 302,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '反社チェックツールを導入したい',
      modal_text: '適切な取引開始判断を行うために反社チェックを導入したいけど、具体的な業務フローやチェックすべき範囲・頻度、使用すべきツールについてわからないのでサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '反社チェックサービス',
      modal_feature_list: [
        '当社を通じて連携する反社チェックツールを使用可能',
        'チェックの一括請負も対応可能',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '反社調査は一般的に反社チェックツールを用いて実施します。新規契約先のみならず継続取引先を含む全取引先について、懸念有無の確認とその証跡を残すことが必要となります。',
      modal_link: '/',
    },
    {
      id: 303,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '証券会社を紹介してほしい',
      modal_text: '上場準備において最も近い伴走者となるのが主幹事証券会社。ビジネスモデルを理解してくれた上で、しっかりサポートしてくれる担当者に担当してほしいので、自社にピッタリな証券会社を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '証券会社のご紹介',
      modal_feature_list: [
        '大手証券会社、中堅証券会社をご紹介',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '上場において、証券会社は最も重要な機能のひとつです。ビジネスモデルの理解、サポートしてくれる担当者、上場時のバリュエーション等を勘案し、自社にピッタリな証券会社を選定することが重要です。',
      modal_link: '/',
    },
    {
      id: 304,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '規程・マニュアルを作成したい',
      modal_text: '上場までには大量の規程・マニュアルの作成が求められるらしい。規程の雛形・サンプルを入手したい。また、自社の実態に整合した規程にアップデートしたいが、社内リソースだけでは負荷が大きいので作成をサポートしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: '規程作成支援サービス',
      modal_feature_list: [
        '規程のテンプレートをご提供',
        '貴社実態に整合した規程の作成をハンズオン支援',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '上場までに求められる規程は少なくとも50個あると言われています。多岐にわたるテンプレートの提供が可能なほか、自社内で作業リソースが確保できない場合でも、貴社実態に即した規程へのアップデートを伴走支援いたします。',
      modal_link: '/',
    },
    {
      id: 305,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '自社サービスや契約書の法務チェックをしたい',
      modal_text: '自社サービスの関連業法に関する把握漏れや、許認可の届出漏れ、契約書の不備などが発生した場合、上場準備のみならず、業績や事業の継続性に大きな影響を与える可能性があるため、専門家による網羅的な法務チェックを実施してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '顧問弁護士のご紹介',
      modal_feature_list: [
        '企業法務や上場準備に強い法律事務所のご紹介',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '自社事業の関連業法の把握漏れや、許認可の届出漏れ、契約書の不備などが発生した場合、上場準備のみならず、業績や事業の継続性に大きな影響を与えることも。会社の成長スピードに合った適切なコンプライアンス体制の構築が肝要です。',
      modal_link: '/',
    },
    {
      id: 306,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '社外監査役が見つからない',
      modal_text: '監査役会を設置することが求められており、３名の監査役を選定する必要があるが、なかなか社外監査役の候補者が見つからない。相性もあることなので自社に合った候補者を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        '豊富な専門性や経験を有した監査役をご紹介',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>本田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_honda.png'),
      modal_commenter_text: '上場においては複数名の監査役で構成される監査役会などの設置が求められます。規模やビジネスモデルのみならず、経営陣との相性にマッチする方を選定することが重要です。',
      modal_link: '/',
    },
    {
      id: 307,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '資金調達したい',
      modal_text: '新規事業や事業拡大、プロダクト開発のための資金を集めたい。誰に何を相談すれば資金調達が成功するかわからないため、計画も含めて相談できるパートナーを探している。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '各ラウンドで資金調達を成功させた経験をもつコンサルタントとビジネスや経営を理解したデザイナーが伴走し、投資家の勘所を押さえた資料を作成',
      ],
      modal_commenter_name: '資金調達コンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: '投資の決定までには多くの人が関与するため、情報が正確に伝わることが重要です。自社の魅力を決定者に届けるには、信頼性のある数字と見やすいデザインを組み合わせた資料が必要不可欠です。',
      modal_link: '/',
    },
    {
      id: 308,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '士業の専門家に相談・連携したい',
      modal_text: '事業の拡大と合わせて、様々な悩みや懸念事項、将来に向けた対応など、各分野の専門家に相談したい。定期的に相談できる顧問契約やアドバイザリー契約も検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '公認会計士によるバックオフィスのトータルサポート',
      modal_feature_list: [
        '社外CFOとして、上場準備企業やベンチャー企業のバックオフィスについて知見のある公認会計士等がサポート',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: 'IPOやM&Aを目指すにあたり、バックオフィスがボトルネックとならないように、将来を見据えて先手先手で体制整備と運用を実施する必要があります！',
      modal_link: '/',
    },
    {
      id: 309,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: 'VCを紹介してほしい',
      modal_text: '資金調達を検討しており、VC・CVCと面談したいが、そもそも投資家に知り合いがいない。またどうやって投資家にアプローチすればいいかもわからない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '事業計画作成や株価算定のみならず、貴社ニーズに合わせた投資家との橋渡しサポート',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'VC、CVCにはむやみにアプローチしても会えるものではありません。まずは1社に事業の魅力が伝わることが重要なので、誰が見ても魅力が伝わるようなストーリーや資料を準備することが重要です。',
      modal_link: '/',
    },
    {
      id: 310,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '社員のモチベーションを上げたい',
      modal_text: 'これからまだまだ会社は成長する。みんなで一丸となって盛り上げていこう！<br>従業員のエンゲージメントを高めるため、持株会やストックオプションの導入を検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '株式報酬制度設計サービス',
      modal_feature_list: [
        '株式報酬制度設計サービス',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '株式報酬制度は、従業員のモチベーションを上げたり、株主である経営陣と同じ目線を持ってもらえたり、優秀な人材の流出を防ぐことなどに対して有効な施策となります。期待する効果や想いが付与対象者に届くよう、綿密に設計しましょう。',
      modal_link: '/',
    },
    {
      id: 311,
      phase_id: 3,
      phase_name: 'N-2期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n2_icon.png'),
      modal_title: '上場前に会社のブランドイメージをアップデートしたい',
      modal_text: '上場することで会社の知名度が大幅に向上するため、投資家やステークホルダー、社会に対してより一層会社の強みをアピールしたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'リブランディングサービス',
      modal_feature_list: [
        '市場調査を実施し、顧客や投資家の期待やニーズを把握した上で、現状のブランドの強み・弱みを分析し、存在意義を再定義しビジュアル化までご支援させていただきます。',
      ],
      modal_commenter_name: 'クリエイティブディレクター<br>坂尾',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_sakao.png'),
      modal_commenter_text: 'これまでスタートアップ企業から上場企業まで幅広いブランディングを行なってきたメンバーで構成されています。インナー、アウターブランディングどちらも合わせて提供できるのが弊社の強みです。',
      modal_link: '/',
    },
    {
      id: 401,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '独立役員が見つからない',
      modal_text: '独立社外取締役の選任が求められているが、なかなか候補者が見つからない。相性もあることなので自社に合った候補者を紹介してほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '役員候補者のご紹介',
      modal_feature_list: [
        '豊富な専門性や経験を有した役員候補者をご紹介',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '独立役員とは、一般株主と利益相反が生じるおそれのない社外取締役又は社外監査役をいいます。コーポレートガバナンスコードでは、少なくとも2名以上の独立社外取締役を選任することが求められており、その人選は慎重に行う必要があります。',
      modal_link: '/',
    },
    {
      id: 402,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: 'Ⅰの部の作成をサポートしてほしい',
      modal_text: '「新規上場申請のための有価証券報告書（Ⅰの部）」を作成しているが、記載内容は多岐にわたり、また記載量が膨大なので、作成サポートや内容チェックをしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: 'Ⅰの部作成支援サービス（コンサルティング） & IPO準備クラウド（SaaS）',
      modal_feature_list: [],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '東証への提出資料である「Ⅰの部」ですが、上場申請期に入ってすぐに、証券会社の審査部への提出資料として、そのドラフトの提出を求められるため、N-1期のうちに作成が必要となります。',
      modal_link: '/',
    },
    {
      id: 403,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: 'Ⅱの部/各種説明資料の作成が大変',
      modal_text: '「新規上場申請のための有価証券報告書（Ⅱの部）」（グロース市場の場合は「新規上場申請者に係る各種説明資料」）を作成しているが、記載内容は多岐にわたり、また記載量が膨大なので、作成サポートや内容チェックをしてほしい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: 'Ⅱの部/各種説明資料作成支援サービス & IPO準備クラウド（SaaS）',
      modal_feature_list: [],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '証券会社の審査部や東証に対して、申請会社のすべてを記した会社説明書とも言えます。「Ⅰの部」と比較して、より広範・詳細な記載が求められ、その作成には多大な労力と時間を要します。',
      modal_link: '/',
    },
    {
      id: 404,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '従業員向けに各種研修を実施したい',
      modal_text: '来期は上場申請期。役職員のスキルアップやルールの社内周知、注意喚起のために、営業研修、コンプライアンス研修、インサイダー取引規制に関する研修などを企画したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'テーマ別研修の企画サービス',
      modal_feature_list: [
        '自社で強化したいテーマに合わせて、当社もしくは協力企業による研修を実施',
      ],
      modal_commenter_name: '上級IPOコンサルタント<br>荒木',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_araki.png'),
      modal_commenter_text: '「法令や規程の周知・徹底のために何を実施しているか」「上場申請期において、更に重要になる情報管理の強化のために何を実施しているか」を語る上で、研修の実施は非常に有効です。',
      modal_link: '/',
    },
    {
      id: 405,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '管理部門人員を増強したい',
      modal_text: '通常業務の遂行に加えて、上場準備作業が大きな負担に。来期は上場準備のピークを迎えさらに負担が増加しそう。業務量を配分するためにも管理部門の人員を増強したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        '管理部門の人員増強をご支援',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'この時期から管理部門の業務量はピークに。ラストスパートを走り切るための人員増強を行う会社も少なくありません。適時開示やIRなど、上場後の管理部門体制も見据え、早めの人員増強を検討するのがおすすめです。',
      modal_link: '/',
    },
    {
      id: 406,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '士業の専門家に相談・連携したい',
      modal_text: '事業の拡大と合わせて、様々な悩みや懸念事項、将来に向けた対応など、各分野の専門家に相談したい。定期的に相談できる顧問契約やアドバイザリー契約も検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '公認会計士によるバックオフィスのトータルサポート',
      modal_feature_list: [
        '社外CFOとして、上場準備企業やベンチャー企業のバックオフィスについて知見のある公認会計士等がサポート',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: 'IPOやM&Aを目指すにあたり、バックオフィスがボトルネックとならないように、将来を見据えて先手先手で体制整備と運用を実施する必要があります！',
      modal_link: '/',
    },
    {
      id: 407,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: 'VCを紹介してほしい',
      modal_text: '資金調達を検討しており、VC・CVCと面談したいが、そもそも投資家に知り合いがいない。またどうやって投資家にアプローチすればいいかもわからない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '事業計画作成や株価算定のみならず、貴社ニーズに合わせた投資家との橋渡しサポート',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'VC、CVCにはむやみにアプローチしても会えるものではありません。まずは1社に事業の魅力が伝わることが重要なので、誰が見ても魅力が伝わるようなストーリーや資料を準備することが重要です。',
      modal_link: '/',
    },
    {
      id: 408,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '社員のモチベーションを上げたい',
      modal_text: 'これからまだまだ会社は成長する。みんなで一丸となって盛り上げていこう！<br>従業員のエンゲージメントを高めるため、持株会やストックオプションの導入を検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '株式報酬制度設計サービス',
      modal_feature_list: [
        '株式報酬制度設計サービス',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '株式報酬制度は、従業員のモチベーションを上げたり、株主である経営陣と同じ目線を持ってもらえたり、優秀な人材の流出を防ぐことなどに対して有効な施策となります。期待する効果や想いが付与対象者に届くよう、綿密に設計しましょう。',
      modal_link: '/',
    },
    {
      id: 409,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '資金調達をサポートしてほしい',
      modal_text: '新規事業や事業拡大、プロダクト開発のための資金を集めたい！<br>誰に何を相談すれば資金調達が成功するかわからないため、計画も含めて相談できるパートナーを探している。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '各ラウンドで資金調達を成功させた経験をもつコンサルタントとビジネスや経営を理解したデザイナーが伴走し、投資家の勘所を押さえた資料を作成',
      ],
      modal_commenter_name: '資金調達コンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: '投資の決定までには多くの人が関与するため、情報が正確に伝わることが重要です。自社の魅力を決定者に届けるには、信頼性のある数字と見やすいデザインを組み合わせた資料が必要不可欠です。',
      modal_link: '/',
    },
    {
      id: 410,
      phase_id: 4,
      phase_name: 'N-1期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n1_icon.png'),
      modal_title: '上場前に会社のブランドイメージをアップデートしたい',
      modal_text: '上場することで会社の知名度が大幅に向上するため、投資家やステークホルダー、社会に対してより一層会社の強みをアピールしたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'リブランディングサービス',
      modal_feature_list: [
        '市場調査を実施し、顧客や投資家の期待やニーズを把握した上で、現状のブランドの強み・弱みを分析し、存在意義を再定義しビジュアル化までご支援させていただきます。',
      ],
      modal_commenter_name: 'クリエイティブディレクター<br>坂尾',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_sakao.png'),
      modal_commenter_text: 'これまでスタートアップ企業から上場企業まで幅広いブランディングを行なってきたメンバーで構成されています。インナー、アウターブランディングどちらも合わせて提供できるのが弊社の強みです。',
      modal_link: '/',
    },
    {
      id: 501,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: '上場申請のための資料作成が大変',
      modal_text: '上場申請に関連して作成が求められる資料が多岐にわたり、いま最も注力すべき本業ビジネスや通常業務に支障が出ている。一時的に対応リソースを増加させることや、外部専門家にサポートしてもらうことを検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item2_img.png'),
      modal_feature: '上場申請に伴いトータルサポート',
      modal_feature_list: [
        '上場申請期は、監査法人/証券会社/証券取引所等とのコミュニケーションや資料作成が急増！経験豊富なプロ人材が徹底サポート',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: '上場申請期は、上場準備メンバーの業務負荷が相当高くなりますので、積極的に外部専門家の力も借りながら走り切ることが大事です！',
      modal_link: '/',
    },
    {
      id: 502,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: '上場前に会社のブランドイメージをアップデートしたい',
      modal_text: '上場することで会社の知名度が大幅に向上するため、投資家やステークホルダー、社会に対してより一層会社の強みをアピールしたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'リブランディングサービス',
      modal_feature_list: [
        '市場調査を実施し、顧客や投資家の期待やニーズを把握した上で、現状のブランドの強み・弱みを分析し、存在意義を再定義しビジュアル化までご支援させていただきます。',
      ],
      modal_commenter_name: 'クリエイティブディレクター<br>坂尾',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_sakao.png'),
      modal_commenter_text: 'これまでスタートアップ企業から上場企業まで幅広いブランディングを行なってきたメンバーで構成されています。インナー、アウターブランディングどちらも合わせて提供できるのが弊社の強みです。',
      modal_link: '/',
    },
    {
      id: 503,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: 'ロードショー資料を作成したい',
      modal_text: '上場承認後は投資家に対して自社の魅力を伝えるロードショーがはじまる。証券会社の審査過程において改めて整理できた自社の強みなども踏まえ、今の「会社概要資料」から、デザイン・内容を大幅にアップデートし、「ロードショーマテリアル」を作成したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'ビジネス資料デザイン支援サービス',
      modal_feature_list: [
        'ロードショーマテリアル（成長可能性資料）の作成経験のあるコンサルタントとデザイナーが、投資家の拡大に向けた資料作成をご支援',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: 'ロードショーマテリアルの作成は、自社の見せ方を再構築し、個人投資家を含む幅広い市場に受け入れられるための重要なプロセスです。資料には「誰にでも伝わる」というわかりやすさが求められます。',
      modal_link: '/',
    },
    {
      id: 504,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: '士業の専門家に相談・連携したい',
      modal_text: '事業の拡大と合わせて、様々な悩みや懸念事項、将来に向けた対応など、各分野の専門家に相談したい。定期的に相談できる顧問契約やアドバイザリー契約も検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '公認会計士によるバックオフィスのトータルサポート',
      modal_feature_list: [
        '社外CFOとして、上場準備企業やベンチャー企業のバックオフィスについて知見のある公認会計士等がサポート',
      ],
      modal_commenter_name: '公認会計士<br>飯塚',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_iiduka.png'),
      modal_commenter_text: 'IPOやM&Aを目指すにあたり、バックオフィスがボトルネックとならないように、将来を見据えて先手先手で体制整備と運用を実施する必要があります！',
      modal_link: '/',
    },
    {
      id: 505,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: 'VCを紹介してほしい',
      modal_text: '資金調達を検討しており、VC・CVCと面談したいが、そもそも投資家に知り合いがいない。またどうやって投資家にアプローチすればいいかもわからない。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '事業計画作成や株価算定のみならず、貴社ニーズに合わせた投資家との橋渡しサポート',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>中島',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_nakajima.png'),
      modal_commenter_text: 'VC、CVCにはむやみにアプローチしても会えるものではありません。まずは1社に事業の魅力が伝わることが重要なので、誰が見ても魅力が伝わるようなストーリーや資料を準備することが重要です。',
      modal_link: '/',
    },
    {
      id: 506,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: '社員のモチベーションを上げたい',
      modal_text: 'これからまだまだ会社は成長する。みんなで一丸となって盛り上げていこう！<br>従業員のエンゲージメントを高めるため、持株会やストックオプションの導入を検討したい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '株式報酬制度設計サービス',
      modal_feature_list: [
        '株式報酬制度設計サービス',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>山本',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_yamamoto.png'),
      modal_commenter_text: '株式報酬制度は、従業員のモチベーションを上げたり、株主である経営陣と同じ目線を持ってもらえたり、優秀な人材の流出を防ぐことなどに対して有効な施策となります。期待する効果や想いが付与対象者に届くよう、綿密に設計しましょう。',
      modal_link: '/',
    },
    {
      id: 507,
      phase_id: 5,
      phase_name: 'N期',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_n_icon.png'),
      modal_title: '資金調達をサポートしてほしい',
      modal_text: '新規事業や事業拡大、プロダクト開発のための資金を集めたい！<br>誰に何を相談すれば資金調達が成功するかわからないため、計画も含めて相談できるパートナーを探している。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '資金調達支援サービス',
      modal_feature_list: [
        '各ラウンドで資金調達を成功させた経験をもつコンサルタントとビジネスや経営を理解したデザイナーが伴走し、投資家の勘所を押さえた資料を作成',
      ],
      modal_commenter_name: '資金調達コンサルタント<br>原田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_harada.png'),
      modal_commenter_text: '投資の決定までには多くの人が関与するため、情報が正確に伝わることが重要です。自社の魅力を決定者に届けるには、信頼性のある数字と見やすいデザインを組み合わせた資料が必要不可欠です。',
      modal_link: '/',
    },
    {
      id: 601,
      phase_id: 6,
      phase_name: '上場後',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_after_icon.png'),
      modal_title: '管理部門担当者を増強したい',
      modal_text: '管理部門の人材のレベルを引き上げたいが、社内リソースの逼迫ですでに採用した人員への教育体制が整えられない。<br>ここから経験者を採用し直すコストは取れないため、コストを抑えながら管理部門人材を役割に応じてスキルアップさせたい。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: '人材紹介サービス',
      modal_feature_list: [
        '顧問紹介サービス',
      ],
      modal_commenter_name: 'IPOコンサルタント<br>本田',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_honda.png'),
      modal_commenter_text: '担当者を限られた時間の中でスキルアップさせるには非常に大きなコストが掛かるもの。上記をスタートアップの社内リソースで確保することはCFOを始め現実的ではないため、外部のスペシャリストをアドバイザーとして活用し、ご担当者の育成プロジェクトを組成しましょう。',
      modal_link: '/',
    },/*
    {
      id: 602,
      phase_id: 6,
      phase_name: '上場後',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_after_icon.png'),
      modal_title: '決算開示プロセスをDX化したい',
      modal_text: 'モーダルテキスト',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'キノウテキスト',
      modal_feature_list: [
        'キノウリスト',
        'キノウリスト',
      ],
      modal_commenter_name: '職業<br>名前',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: 'セツメイブン',
      modal_link: '/',
    },
    {
      id: 603,
      phase_id: 6,
      phase_name: '上場後',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_after_icon.png'),
      modal_title: '管理業務の一部をアウトソースしたい',
      modal_text: 'モーダルテキスト',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'キノウテキスト',
      modal_feature_list: [
        'キノウリスト',
        'キノウリスト',
      ],
      modal_commenter_name: '職業<br>名前',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: 'セツメイブン',
      modal_link: '/',
    },
    {
      id: 604,
      phase_id: 6,
      phase_name: '上場後',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_after_icon.png'),
      modal_title: '社内資料の統一化を図りたい',
      modal_text: '部署ごとに異なるフォーマットやデザインを使用しており、統一が難しいことや、長年蓄積された異なるフォーマットの資料を統一するには膨大な時間とコストがかかる。',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'ビジネス資料デザイン支援サービス',
      modal_feature_list: [
        'ビジュアルを含めたブランディングの経験があるデザイナーが、フォーマットの統一や運用ルールを定着化し、作成や管理工数を下げます',
      ],
      modal_commenter_name: 'クリエイティブディレクター<br>坂尾',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: 'セツメイブン',
      modal_link: '/',
    },
    {
      id: 605,
      phase_id: 6,
      phase_name: '上場後',
      modal_icon_src: withPrefix('/images/phaseinfo/step2_modal_after_icon.png'),
      modal_title: '決算説明資料をもっと株主に伝わりやすくしたい',
      modal_text: 'モーダルテキスト',
      modal_img_src: withPrefix('/images/phaseinfo/step2_modal_item1_img.png'),
      modal_feature: 'キノウテキスト',
      modal_feature_list: [
        'キノウリスト',
        'キノウリスト',
      ],
      modal_commenter_name: '職業<br>名前',
      modal_commenter_src: withPrefix('/images/phaseinfo/step2_modal_commenter_kato.png'),
      modal_commenter_text: 'セツメイブン',
      modal_link: '/',
    },*/
  ]
  
  
  return (
    <section id="phaseinfo"
      css={css`
        padding-top: 0px;
        @media (min-width: 1081px) {
          padding-top: 90px;
        }
      `}
      className={className}
    >
    <div 
      css={css`
        position: relative;
        overflow: hidden;
        z-index: 1;
        background: linear-gradient(
          90deg,
          #00B3A7 0%,
          #71D9D2 51%,
          #00B3A7 100%
        );
        padding: 15px;

        @media ${getScreen('pc')} {
          background: linear-gradient(
            90deg,
            #00B3A7 0%,
            #71D9D2 51%,
            #00B3A7 100%
          );
          padding: 30px;
          min-height: 800px;
          overflow: hidden;
        }
      `}
    >
      <img 
        css={css`
          display: none;
          @media ${getScreen('pc')} {
            position: absolute;
            left: 50%;
            top: 50%;
            z-index: -1;
            display: block;
            margin: auto;
            width: 96%;
            height: 96%;
            transform: translate(-50%, -50%);
          }
        `}
        src={withPrefix('/images/phaseinfo/phase_bg.png')} alt="" width="1440"
      />
      <img 
        css={css`
          position: absolute;
          left: 50%;
          top: 50%;
          z-index: -1;
          margin: auto;
          width: 96%;
          height: 96%;
          transform: translate(-50%, -50%);
          @media ${getScreen('pc')} {
            display: none;
          }
        `}
        src={withPrefix('/images/phaseinfo/phase_bg_sp.png')} alt="" width="870"
      />
    {!isStepNum && 
      <div
        css={css`
          position: relative;
          
          @media ${getScreen('pc')} {
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            left: 0px;
            top: 0px;
            @media ${getScreen('pc')} {
            }
          `}
        >
          <h2
            css={css`
              img {
                width: 224px;
                @media ${getScreen('pc')} {
                  width: revert-layer;
               }
              }
            `}
          ><img src={withPrefix('/images/phaseinfo/title.png')} alt="ユニちゃんと巡る！IPO準備ツアー" width="380" /></h2>
        </div>
        <div
          css={css`
            margin: auto;
            margin-bottom: 40px;
            padding-top: 100px;
            
            @media ${getScreen('pc')} {
            }
          `}
        >
          <h3
            css={css`
              max-width: 630px;
              width: 100%;
              margin: auto;
              
              @media ${getScreen('pc')} {
              }
              
              img {
                width: 100%;
              }
            `}
          ><img src={withPrefix('/images/phaseinfo/step1_title.png')} alt="あなたのフェーズはどれ？？" width="630" /></h3>
        </div>
        <ol
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
            max-width: 600px;
            margin: auto;
            padding: 0 10px;
            
            
            @media ${getScreen('pc')} {
              gap: 30px;
              flex-wrap: nowrap;
              max-width: none;
              padding: auto;
            }
            
            li {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              max-width: 150px;
              width: 29%;
              aspect-ratio: 1;
              border: 1px solid #00B3A7;
              border-radius: 100px;
              
              @media ${getScreen('pc')} {
                width: 14.5%;
                max-width: 170px;
              }
              @media (min-width: 1201px) {
                width: 170px;
              }
              
              & + li {
                &::after {
                  content: "";
                  position: absolute;
                  left: -15px;
                  top: 0;
                  bottom: 0;
                  margin: auto;
                  width: 10px;
                  height: 22px;
                  background: url(${withPrefix('/images/phaseinfo/icon_m_arrow.png')}) no-repeat scroll 0 0;
                  background-size: cover;
                  
                  @media ${getScreen('pc')} {
                    left: -23px;
                    width: 13px;
                    height: 30px;
                  }
                }
              }
              
              button {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 10px;
                
                height: 100%;
                width: 100%;
                padding: 10px;
                
                border: 0px;
                border-radius: 100px;
                cursor: pointer;
                outline: 0;
                border: 0;
                background: radial-gradient(#ffffff 0%, #ffffff 64%, transparent 65%);
                
                @media ${getScreen('pc')} {
                  gap: 10px;
                }
              }
              
              strong {
                color: #00B3A7;
                font-weight: bold;
                font-size: 14px;
                
                @media ${getScreen('pc')} {
                  font-size: 16px;
                }
                @media (min-width: 1201px) {
                  font-size: 18px;
                }
              }
              
              img {
                width: 80%;
                @media ${getScreen('pc')} {
                  width: 70%;
                }
                @media (min-width: 1201px) {
                  width: revert-layer;
                }
              }
              
              .icon {
                position: absolute;
                bottom: -5px;
                left: 0;
                right: 0;
                margin: auto;
                width: revert-layer;
              }
              
              &:hover {
                button {
                  background: radial-gradient(#00B3A7 0%, #00B3A7 64%, transparent 65%);
                }
                strong {
                  color: #ffffff;
                }
              }
            }
            li.active {
              button {
                background: radial-gradient(#00B3A7 0%, #00B3A7 64%, transparent 65%);
              }
              strong {
                color: #ffffff;
              }
              
              &::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: -35px;
                margin: auto;
                width: 23px;
                height: 14px;
                clip-path: polygon(0 0, 100% 0%, 50% 100%);
                background-color: #00B3A7;
                
                @media ${getScreen('pc')} {
                  width: 40px;
                 height: 24px;
                }
              }
            }
          `}
        >
        {step1_list.map((item, i) => (
          <li
            className={item.id === isStep1ContentsNum ? 'active' : ''}
          ><button onMouseEnter={() => changeStep1Contents1Num(item.id)} onClick={() => changeStepNum(2)}>
            <strong>{item.phase_name}</strong>
            <div><img src={item.img_step1_src} alt="" width={item.img_step1_width} /></div>
            {item.id === 5 && 
              <img className="icon" src={withPrefix('/images/phaseinfo/step1_n_ipo.png')} alt="ipo" width="90" />
            }
          </button></li>
        ))}
        </ol>
        <div
          css={css`
            display: flex;
            justify-content: center;
            
            @media ${getScreen('pc')} {
            }
            
            .step1box {
              &_name {
                margin-bottom: 20px;
                text-align: center;
                font-size: 32px;
                font-weight: bold;
                color: #00B3A7;
                
                @media ${getScreen('pc')} {
                  font-size: 56px;
                }
              }
              
              dd {
                margin-bottom: 30px;
                font-size: 12px;
                font-weight: 500;
                line-height: 1.8;
                color: #6D6C79;
                
                @media ${getScreen('pc')} {
                  font-size: 14px;
                }
              }
              dd.no_sp {
                display: none;
                @media ${getScreen('pc')} {
                  display: block;
                }
              }
              &_text {
                max-width: 644px;
                margin-left: auto;
                margin-right: auto;
              }
              &_list {
                display: flex;
                justify-content: center;
                gap: 10px;
                
                li {
                  position: relative;
                  padding: 10px 15px;
                  padding-left: 28px;
                  border-radius: 8px;
                  font-size: 14px;
                  line-height: 1.0;
                  font-weight: bold;
                  color: #00B3A7;
                  background-color: #ffffff;
                  
                  &::before {
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    top: 0;
                    bottom: 0;
                    left: 15px;
                    margin: auto;
                    background: #00b3a7;
                    border-radius: 50%;
                    position: absolute;
                  }
                }
              }
            }
          `}
        >
          {!isStep1ContentsNum && 
            <dl className="step1box">
              <dt className="step1box_name">{step1_list[0].phase_name}</dt>
              <dd className="step1box_text" dangerouslySetInnerHTML={{
                __html: `${step1_list[0].phase_text.replace(/\n/g, '<br />')}`,
              }}></dd>
              <dd className="no_sp"><ul className="step1box_list">
              {step1_list[0].phase_list.map((listitem, i) => (
                <li>{listitem}</li>
              ))}
              </ul></dd>
            </dl>
          }
        {step1_list.map((item, i) => (
        <>
          {isStep1ContentsNum === item.id && 
            <dl className="step1box">
              <dt className="step1box_name">{item.phase_name}</dt>
              <dd className="step1box_text" dangerouslySetInnerHTML={{
                __html: `${item.phase_text.replace(/\n/g, '<br />')}`,
              }}></dd>
              <dd className="no_sp"><ul className="step1box_list">
              {item.phase_list.map((listitem, i) => (
                <li>{listitem}</li>
              ))}
              </ul></dd>
            </dl>
          }
        </>
        ))}
        </div>
        <div
          css={css`
            text-align: center;
            
            @media ${getScreen('pc')} {
            }
            
            button {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              max-width: 454px;
              width: calc(100% - 10px);
              height: 64px;
              margin: auto;
              padding: 10px 20px;
              border: 0px solid #00B3A7;
              border-radius: 30px;
              font-size: 14px;
              font-weight: bold;
              color: #ffffff;
              
              cursor: pointer;
              outline: 0;
              background-color: #00B3A7;
              
              
              &:hover {
                &::before {
                  opacity: 1.0;
                }
              }
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 9999px;
                opacity: 0;
                transition: opacity 0.4s ease;
              }
              
              @media ${getScreen('pc')} {
                width: 454px;
                font-size: 24px;
              }
            }
          `}
        >
        </div>
      </div>
    }
    {isStepNum === 2 && 
      <>
      <div
        css={css`
          position: relative;
          
          @media ${getScreen('pc')} {
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            right: 0px;
            top: 0px;
            z-index: 1;
            
            @media ${getScreen('pc')} {
            }
          `}
        >
          <h2
            css={css`
              img {
                width: 158px;
                @media ${getScreen('pc')} {
                  width: revert-layer;
               }
              }
            `}
          ><img src={withPrefix('/images/phaseinfo/title.png')} alt="ユニちゃんと巡る！IPO準備ツアー" width="380" /></h2>
        </div>
        <div
          css={css`
            position: absolute;
            left: 0px;
            top: 0px;
            z-index: 1;
            
            @media ${getScreen('pc')} {
              left: 20px;
              top: 30px;
            }
            
            button {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 180px;
              height: 48px;
              margin: auto;
              padding: 10px 10px;
              padding-left: 30px;
              border: 2px solid #00B3A7;
              border-radius: 30px;
              font-size: 14px;
              font-weight: bold;
              color: #00B3A7;
              
              cursor: pointer;
              outline: 0;
              background-color: #ffffff;
              
              @media ${getScreen('pc')} {
                width: 288px;
                height: 64px;
                padding-left: 50px;
                font-size: 20px;
              }
              
              transition: color 0.4s ease;
              
              &:hover {
                color: rgba(0, 179, 167, 0.6);
                &::before {
                  opacity: 0.6;
                }
              }
              
              &::before {
                content: "";
                position: absolute;
                left: 15px;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 10px;
                height: 15px;
                background: url(${withPrefix('/images/phaseinfo/icon_s_arrow.png')}) no-repeat scroll 0 0;
                background-size: cover;
                
                opacity: 1.0;
                transition: opacity 0.4s ease;
                
                @media ${getScreen('pc')} {
                  left: 30px;
                  width: 13px;
                  height: 20px;
                }
              }
            }
          `}
        >
          <button onClick={() => changeStepNum(false)}>フェーズ選択に戻る</button>
        </div>
        <div
          css={css`
            position: relative;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            max-width: 1180px;
            padding-top: 60px;
            margin: auto;
            margin-bottom: 50px;
            
            @media ${getScreen('pc')} {
              padding-top: 120px;
            }
            
            h3{
              width: 100%;
              margin-bottom: 10px;
              font-size: 24px;
              line-height: 1.0;
              font-weight: bold;
              color: #00B3A7;
              text-align: center;
              text-stroke: 10px #ffffff;
              -webkit-text-stroke: 10px #ffffff;
              paint-order: stroke;
              
              @media ${getScreen('pc')} {
                font-size: 56px;
              }
            }
            .img {
              position: absolute;
              left: 0;
              right: 0;
              bottom: -20px;
              z-index: -1;
              margin: auto;
              width: 180px;
              
              @media ${getScreen('pc')} {
                width: revert-layer;
              }
            }
            
            p{
              max-width: 700px;
              margin: auto;
              font-size: 12px;
              font-weight: 500;
              line-height: 1.8;
              color: #6D6C79;
              text-align: center;
              
              @media ${getScreen('pc')} {
                font-size: 14px;
                padding-right: 120px;
                padding-left: 120px;
                max-width: calc(700px + 240px);
              }
            }
            
            button {
              position: relative;
              
              display: none;
              
              cursor: pointer;
              outline: 0;
              border: 0;
              background-color: transparent;
              
              height: 28px;
              font-size: 28px;
              line-height: 1.0;
              font-weight: bold;
              color: #00B3A7;
              
              opacity: 1.0;
              transition: opacity 0.4s ease;
              
              &:hover {
                opacity: 0.8;
              }
              
              &::after {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 13px;
                height: 30px;
                background: url(${withPrefix('/images/phaseinfo/icon_m_arrow.png')}) no-repeat scroll 0 0;
                background-size: cover;
              }
              
              @media ${getScreen('pc')} {
                display: block;
              }
              
            }
            .prev{
              position: absolute;
              left: 0;
              top: 195px;
              margin: auto;
              padding-left: 40px;
              
              &::after {
                left: 0;
                transform: rotate(180deg);
              }
            }
            .next{
              position: absolute;
              right: 0;
              top: 195px;
              margin: auto;
              padding-right: 40px;
              
              &::after {
                right: 0;
              }
            }
          `}
        >
          {step1_list.map((item, i) => (
          <>
            {isStep1ContentsNum === item.id && 
            <>
              <h3 dangerouslySetInnerHTML={{
                __html: `${item.phase_name.replace(/\n/g, '<br />')}`,
              }}></h3>
              <img className="img" src={item.img_step2_title_src} alt="" width={item.img_step2_title_width} />
              <p dangerouslySetInnerHTML={{
                __html: `${item.phase_text.replace(/\n/g, '<br />')}`,
              }}></p>
              
              {isStep1ContentsNum !== 1 && 
                <button className="prev" data-value={(isStep1ContentsNum - 1)} data-value_test={step1_list[(i-1)].id} onClick={() => changeStep1Contents1Num(step1_list[(i-1)].id)}>{step1_list[(i-1)].phase_name}</button>
              }
              {isStep1ContentsNum !== 6 && 
                <button className="next" data-value={(isStep1ContentsNum + 1)} data-value_test={step1_list[(i+1)].id} onClick={() => changeStep1Contents1Num(step1_list[(i+1)].id)}>{step1_list[(i+1)].phase_name}</button>
              }
            </>
            }
          </>
          ))}
        </div>
        <div
          css={css`
            @media ${getScreen('pc')} {
            }
            
            ol {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 10px;
              max-width: 1180px;
              margin: auto;
              @media ${getScreen('pc')} {
                gap: 20px;
              }
              
              li {
                display: flex;
                align-items: center;
                justify-content: center;
                width: calc(50% - 10px);
                height: 60px;
                margin: auto;
                border: 3px solid #00B3A7;
                border-radius: 16px;
                box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.16);
                background: #ffffff;
                
                @media ${getScreen('pc')} {
                  width: calc(25% - 20px);
                  height: 70px;
                  margin: initial;
                  border-radius: 8px;
                }
                
              }
              button {
                cursor: pointer;
                width: 100%;
                height: 100%;
                padding: 5px;
                outline: 0;
                border: 0;
                color: #00B3A7;
                font-weight: bold;
                font-size: 10px;
                line-height: 1.4;
                background-color: transparent;
                
                opacity: 1.0;
                transition: opacity 0.4s ease;
                
                @media ${getScreen('pc')} {
                  font-size: 14px;
                }
                
                &:hover {
                  opacity: 0.6;
                }
              }
            }
            
          `}
        >
        {step1_list.map((step1item, i) => (
        <>
          {isStep1ContentsNum === step1item.id && 
          <ol>
            {step2_list.map((step2item, i) => (
            <>
              {isStep1ContentsNum === step2item.phase_id && 
                <li><button onClick={() => openModal(step2item.id)}>
                  <p dangerouslySetInnerHTML={{
                    __html: `${step2item.modal_title.replace(/\n/g, '<br />')}`,
                  }}></p>
                </button></li>
              }
            </>
            ))}
          </ol>
          }
        </>
        ))} 
        </div>
      </div>
      {step1_list.map((item, i) => (
      <>
        {isStep1ContentsNum === item.id && 
        <>
        <img 
          css={css`
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: -1;
            width: 80px;

            @media ${getScreen('pc')} {
              width: revert-layer;
            }
          `}
         src={item.img_step2_icon_src} alt="" width={item.img_step2_icon_width} />
        </>
        }
      </>
      ))}
      </>
    }
    
    {isOpenModalVisible && (
      <Modal
        isOpen={isOpenModalVisible}
        onRequestClose={closeModal}
        className=""
        style={{
          overlay: {
            height: '100%',
            width: '100%',
            zIndex: '1000',
            background: 'rgba(62,65,83,0.2)'
          },
          content: {
            margin: 'auto',
            padding: windowWidth > 870 ? '30px': '15px',
            borderRadius: windowWidth > 870 ? '32px' : '24px',
            inset: windowWidth > 870 ? '40px' : '15px',
            maxWidth: windowWidth > 870 ? '1200px': 'none',
            maxHeight: windowWidth > 870 ? '750px': 'none',
          },
        }}
      >
        <div
          css={css`
            position: relative;
          `}
        >
          <div
            css={css`
              position: relative;
              max-width: 1020px;
              margin: auto;
              
              .headline {
                position: relative;
                padding: 20px;
                padding-top: 40px;
                padding-left: 0px;
                padding-right: 0px;
                padding-bottom: 0px;
                margin-bottom: 10px;
                
                @media ${getScreen('pc')} {
                  padding-top: 55px;
                  padding-left: 170px;
                  padding-right: 90px;
                  margin-bottom: 50px;
                }
                
                &::before {
                  content: "";
                  position: absolute;
                  left: 35px;
                  bottom: -20px;
                  width: 110px;
                  height: 110px;
                  background: url(${withPrefix('/images/phaseinfo/step2_modal_title_img.png')}) no-repeat scroll 0 0;
                  background-size: 110px auto;
                  
                  display: none;
                  
                  @media ${getScreen('pc')} {
                    display: block;
                  }
                  
                }
                
                .headline_title {
                  font-size: 16px;
                  font-weight: bold;
                  color: #5C617C;
                  
                  @media ${getScreen('pc')} {
                    font-size: 24px;
                  }
                  
                }
                &_phase {
                  position: absolute;
                  left: 0;
                  top: 0;
                  display: flex;
                  justify-content: center;
                  align-content: center;
                  
                  font-size: 14px;
                  font-weight: bold;
                  color: #00B3A7;
                  
                  @media ${getScreen('pc')} {
                    font-size: 20px;
                  }
                  
                  
                  img {
                    margin-right: 10px;
                    width: 32px;
                    
                    @media ${getScreen('pc')} {
                      width: revert-layer;
                    }
                    
                  }
                }
                &_text {
                  font-size: 12px;
                  line-height: 1.8;
                  font-weight: 500;
                  color: #5C617C;
                  
                  @media ${getScreen('pc')} {
                    font-size: 16px;
                  }
                }
              }
              .bodyline {
                margin-bottom: 20px;
                
                @media ${getScreen('pc')} {
                  margin-bottom: 30px;
                }
                
                &_catch {
                  margin-bottom: 20px;
                  padding: 5px 10px;
                  font-size: 12px;
                  font-weight: bold;
                  color: #ffffff;
                  background-color: #00B3A7;
                  
                  @media ${getScreen('pc')} {
                    margin-bottom: 40px;
                    font-size: 16px;
                  }
                }
                &_box {
                  display: grid;
                  grid-template-columns: repeat(2, auto);
                  grid-template-rows: repeat(4, auto);
                  gap: 5px;
                  
                  @media ${getScreen('pc')} {
                    grid-template-columns: 435px 1fr;
                    grid-template-rows: repeat(3, auto);
                    gap: 10px;
                  }
                  
                  
                  &_imgbox {
                    grid-column: 1 / 3;
                    grid-row: 1 / 2;
                    text-align: center;
                    
                    @media ${getScreen('pc')} {
                      grid-column: 1 / 2;
                      grid-row: 1 / 3;
                      text-align: left;
                    }
                    
                    img {
                      width: 80%;
                      max-width: 435px;
                    }
                    
                  }
                  &_infobox {
                    grid-column: 1 / 3;
                    grid-row: 2 / 3;
                    margin-bottom: 0px;
                    
                    @media ${getScreen('pc')} {
                      grid-column: 2 / 3;
                      grid-row: 1 / 2;
                      margin-bottom: 20px;
                    }
                    
                    dt {
                      margin-bottom: 10px;
                      font-size: 16px;
                      font-weight: bold;
                      color: #00B3A7;
                      
                      @media ${getScreen('pc')} {
                        font-size: 24px;
                      }
                    }
                    dd {
                      li {
                        position: relative;
                        padding-left: 25px;
                        font-size: 12px;
                        font-weight: 500;
                        color: #5C617C;
                        
                        @media ${getScreen('pc')} {
                          font-size: 16px;
                        }
                        
                        &::before {
                          content: '';
                          display: block;
                          width: 8px;
                          height: 8px;
                          top: 7px;
                          left: 7px;
                          margin: auto;
                          background: #00b3a7;
                          border-radius: 50%;
                          position: absolute;
                          
                          @media ${getScreen('pc')} {
                            top: 12px;
                          }
                          
                        }
                        
                        + li {
                          margin-top: 5px;
                        }
                      }
                    }
                  }
                  &_cmtbox {
                    grid-column: 1 / 3;
                    grid-row: 3 / 4;
                    
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    
                    @media ${getScreen('pc')} {
                      grid-column: 2 / 3;
                      grid-row: 2 / 3;
                      
                      align-items: center;
                    }
                    
                    figure {
                      text-align: center;
                      
                      figcaption {
                        min-width: 90px;
                        text-align: center;
                        font-size: 10px;
                        font-weight: 500;
                        color: #5C617C;
                      }
                    }
                    p {
                      position: relative;
                      padding: 10px;
                      margin-left: 20px;
                      border-radius: 16px;
                      font-size: 12px;
                      font-weight: 500;
                      color: #5C617C;
                      background-color: #DEF6F5;
                      
                      @media ${getScreen('pc')} {
                        padding: 20px;
                        font-size: 16px;
                      }
                      
                      
                      &::before {
                        content: "";
                        position: absolute;
                        left: -15px;
                        top: 25px;
                        margin: auto;
                        width: 15px;
                        height: 15px;
                        clip-path: polygon(100% 0, 0 50%, 100% 100%);
                        background-color: #DEF6F5;
                        
                        @media ${getScreen('pc')} {
                          bottom: 0;
                          top: 0;
                        }
                      }
                    }
                  }
                }
              }
              .footline {
                a {
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  max-width: 412px;
                  height: 50px;
                  padding: 10px;
                  margin: auto;
                  border-radius: 30px;
                  font-size: 16px;
                  font-weight: bold;
                  color: #ffffff;
                  background: linear-gradient(
                    45deg,
                    #FE8422 0%,
                    #FF9925 100%
                  );
                  
                  
                  &:hover {
                    &::before {
                      opacity: 1.0;
                    }
                  }
                  &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(255, 255, 255, 0.2);
                    border-radius: 9999px;
                    opacity: 0;
                    transition: opacity 0.4s ease;
                  }
                  
                  @media ${getScreen('pc')} {
                    width: 412px;
                  }
                }
              }
            `}
          >
          {step2_list.map((step2item, i) => (
          <>
            {isOpenModalNum === step2item.id && 
            <div>
              <div className="headline">
                <p className="headline_phase"><img src={step2item.modal_icon_src} alt="" width="43" />{step2item.phase_name}</p>
                <p className="headline_title"><strong dangerouslySetInnerHTML={{
                    __html: `${step2item.modal_title.replace(/<br>/g, '')}`,
                  }}></strong></p>
                <p className="headline_text" dangerouslySetInnerHTML={{
                  __html: `${step2item.modal_text.replace(/\n/g, '<br />')}`,
                }}></p>
              </div>
              <div className="bodyline">
                <p className="bodyline_catch">Uniforceで課題をまるっと解決</p>
                <div className="bodyline_box">
                  <div className="bodyline_box_imgbox"><img src={step2item.modal_img_src} alt="" width="435" /></div>
                  <dl className="bodyline_box_infobox">
                    <dt>{step2item.modal_feature}</dt>
                  {step2item.modal_feature_list && <dd><ul>
                    {step2item.modal_feature_list.map((feature_item, i) => (
                      <li>{feature_item}</li>
                    ))}
                    </ul></dd>
                  }
                  </dl>
                  <div className="bodyline_box_cmtbox">
                    <figure><img src={step2item.modal_commenter_src} alt="" width="60" />
                      <figcaption  dangerouslySetInnerHTML={{
                        __html: `${step2item.modal_commenter_name.replace(/\n/g, '<br />')}`,
                      }}></figcaption>
                    </figure>
                    <p dangerouslySetInnerHTML={{
                    __html: `${step2item.modal_commenter_text.replace(/\n/g, '<br />')}`,
                    }}></p>
                  </div>
                </div>
              </div>
              <div className="footline">
                <a href="https://share.hsforms.com/1_8y1fiw0RnipKf92-IK6hAniuky" target="_blank" rel="noreferrer">相談してみる</a>
              </div>
            </div>
            }
          </>
          ))}
          </div>
          <button 
            css={css`
              cursor: pointer;
              position: absolute;
              right: 0;
              top: 0;
              height: 32px;
              width: 32px;
              padding: 0;
              outline: 0;
              border: 0;
              border-radius: 25px;
              font-size: 0;
              background: #EBEFF1;
              
              opacity: 1.0;
              transition: opacity 0.4s ease;
              
              &:hover {
                opacity: 0.6;
              }
              
              @media ${getScreen('pc')} {
                height: 48px;
                width: 48px;
              }
              
              &::before {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
                height: 2px;
                width: 18px;
                background: #5C617C;
                transform: rotate(45deg);

                @media ${getScreen('pc')} {
                  width: 26px;
                }
                
              }
              &::after {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
                height: 2px;
                width: 18px;
                background: #5C617C;
                transform: rotate(-45deg);
                
                @media ${getScreen('pc')} {
                  width: 26px;
                }
              }
            `}
            onClick={() => closeModal()}
          >閉じる</button>
        </div>
      </Modal>
    )}
      
    </div>
    </section>
  );
};
